export enum EProjectType {
  Desktop = 1,
  Mobile = 2
}

export enum EProjectFeature {
  Datasource = 1,
  Workflow = 2,
  EmailTemplate = 3,
  PdfReport = 4,
  ScheduledJobs = 5,
  ConfigurationManager = 6,
  Archive = 7
}
